import React from 'react';

const Energiewende: React.FC = () => (
  <section>
    <div className="container">
      <h2 className="page-heading">
        Sind Sie bereit für die <span style={{ color: '#FFA500' }}>Energiewende?</span>
      </h2>
      <p>
        Die Abgabe der kommunalen Wärmeplanung rückt näher. Bis Juni 2028 müssen Städte, Gemeinden und Kommunen bis 100.000 Einwohner ihre kommunale Wärmeplanung einreichen.
        Bei der Umstellung auf erneuerbare Energieträger beraten und begleiten wir Sie und sorgen dafür,
        dass positive Energie fließt - im Gemeinderat, in Fachausschüssen, bei Bürgerversammlungen und natürlich in Ihrer Stadt oder Gemeinde.
      </p>
      <div style={{ textAlign: 'center', marginTop: '1rem' }}>
        <a href="#zielSection" className="button">Termin vereinbaren</a>
      </div>
    </div>
  </section>
);

export default Energiewende;
